import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNil } from 'lodash';
import { bindActionCreators } from 'redux';
import { initialize } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import FaArrowLeft from 'react-icons/lib/fa/arrow-left';
import { actionsRequest, ActionType } from 'services/actions';
import { selectResult as selectWireResult, updateWireRequest } from 'services/updateWire';
import { selectResult as selectSuspendWireResult, suspendWireRequest } from 'services/suspendWire';
import { selectResults as selectRecentDeposits } from 'services/recentDeposits';
import { selectResults as selectAtlasResults } from 'services/atlasRequest';
import {
  addressRequest,
  selectResults as selectAddressResults,
  selectError as selectAddressError,
} from 'services/addressPreview';
import DetailsHeader from 'components/DetailsHeader';
import { ActionState, EvaluatedActionType, formatters, TRANSFER_TYPES } from 'common';
import { Grid, Row } from 'react-bootstrap';
import AmountAvailablePanel from 'components/AmountAvailablePanel';
import ActionsPanel from 'components/ActionsPanel';
import AuditTrailPanel from 'components/AuditTrailPanel';
import CreateActionForm from 'components/CreateActionForm';
import TransferPanel from 'components/TransferPanel';
import UpdateAmountForm from 'components/UpdateAmountForm';
import RetirementPanel from 'components/RetirementPanel';
import MarginCallPanel from 'components/MarginCallPanel';
import RecentDepositsPanel from 'components/RecentDepositsPanel';
import TabbedDetailsPanel from 'components/TabbedDetailsPanel';
import AccountPanel from 'components/AccountPanel';
import IncomingWiresAccountPanel from 'components/AccountPanel/IncomingWiresAccountPanel';
import RejectTransferForm from 'components/RejectTransferForm';
import ReopenTransferForm from 'components/ReopenTransferForm';
import ReturnTransferForm from 'components/ReturnTransferForm';
import SuspendWireTransferForm from 'components/SuspendWireTransferForm';
import CancelTransferForm from 'components/CancelTransferForm';
import TravelRuleDetailsPanel from 'components/TravelRuleDetailsPanel';
import TransferFeesPanel from 'components/TransferFeesPanel';
import Spinner from 'components/Spinner';
import {
  selectResult,
  selectTransferId,
  detailsRequest,
  selectHasActionResolvableByCurrentUser,
  IS_INCOMING_WIRE,
} from 'services/details';
import {
  selectShouldAllowEditAmount,
  selectIsDetailsServiceLoading,
  selectUpdateWireFailure,
  accountFormSelector,
  selectShowAllFields,
} from './selectors';
import { clearAllErrors } from '../App/actions';
import messages from './messages';
import styles from './styles.css';
import UpdateAccountForm from '../../components/UpdateAccountForm';
import WireInstructionPanel from '../../components/WireInstructionsPanel';
import WireDescriptionsPanel from '../../components/WireDescriptionsPanel';
import UpdateWireDescriptionsForm from '../../components/UpdateWireDescriptionsForm';

export class Details extends PureComponent {
  static propTypes = {
    actionsRequest: PropTypes.func.isRequired,
    transfer: PropTypes.object,
    detailsRequest: PropTypes.func.isRequired,
    updateWireRequest: PropTypes.func.isRequired,
    shouldAllowEditAmount: PropTypes.bool.isRequired,
    recentDepositsResults: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    isDetailsLoading: PropTypes.bool.isRequired,
    searchServiceTransferId: PropTypes.string,
    hasActionResolvableByCurrentUser: PropTypes.bool.isRequired,
    clearAllErrors: PropTypes.func.isRequired,
    showAllFields: PropTypes.bool.isRequired,
    wireUpdateResult: PropTypes.object,
    wireUpdateFailure: PropTypes.bool,
    formInitialize: PropTypes.func.isRequired,
    transferAccountValue: PropTypes.string.isRequired,
    isSuspendable: PropTypes.bool.isRequired,
    suspendWireRequest: PropTypes.func.isRequired,
    suspendWireResult: PropTypes.object,
    atlasResults: PropTypes.object,
    addressRequest: PropTypes.func.isRequired,
    addressResult: PropTypes.object,
    addressError: PropTypes.object,
  };

  static defaultProps = {
    transfer: undefined,
    searchServiceTransferId: '',
    wireUpdateResult: null,
    wireUpdateFailure: false,
    suspendWireResult: null,
    atlasResults: '-',
    addressResult: null,
    addressError: null,
  };

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.handleApproveActionSubmit = this.handleApproveActionSubmit.bind(this);
    this.handleRejectTransferSubmit = this.handleRejectTransferSubmit.bind(this);
    this.showRejectTransferFormModal = this.showRejectTransferFormModal.bind(this);
    this.hideRejectTransferFormModal = this.hideRejectTransferFormModal.bind(this);
    this.handleReopenTransferSubmit = this.handleReopenTransferSubmit.bind(this);
    this.showReopenTransferFormModal = this.showReopenTransferFormModal.bind(this);
    this.hideReopenTransferFormModal = this.hideReopenTransferFormModal.bind(this);
    this.handleReturnTransferSubmit = this.handleReturnTransferSubmit.bind(this);
    this.showReturnTransferFormModal = this.showReturnTransferFormModal.bind(this);
    this.hideReturnTransferFormModal = this.hideReturnTransferFormModal.bind(this);
    this.showSuspendTransferFormModal = this.showSuspendTransferFormModal.bind(this);
    this.hideSuspendTransferFormModal = this.hideSuspendTransferFormModal.bind(this);
    this.toggleCancelTransferFormModal = this.toggleCancelTransferFormModal.bind(this);
    this.handleCancelTransferSubmit = this.handleCancelTransferSubmit.bind(this);
    this.handleSuspendWireSubmit = this.handleSuspendWireSubmit.bind(this);
    this.handleUpdateAmountSubmit = this.handleUpdateAmountSubmit.bind(this);
    this.showUpdateAmountFormModal = this.showUpdateAmountFormModal.bind(this);
    this.hideUpdateAmountFormModal = this.hideUpdateAmountFormModal.bind(this);
    this.showUpdateAccountFormModal = this.showUpdateAccountFormModal.bind(this);
    this.hideUpdateAccountFormModal = this.hideUpdateAccountFormModal.bind(this);
    this.handleUpdateAccountSubmit = this.handleUpdateAccountSubmit.bind(this);
    this.showUpdateWireDescriptionsFormModal = this.showUpdateWireDescriptionsFormModal.bind(this);
    this.hideUpdateWireDescriptionsFormModal = this.hideUpdateWireDescriptionsFormModal.bind(this);
    this.handleUpdateWireDescriptionsSubmit = this.handleUpdateWireDescriptionsSubmit.bind(this);
    this.hideCreateActionFormModal = this.hideCreateActionFormModal.bind(this);
    this.handleCreateActionSubmit = this.handleCreateActionSubmit.bind(this);
    this.showCreateActionFormModal = this.showCreateActionFormModal.bind(this);
    this.showMailingAddressModal = this.showMailingAddressModal.bind(this);
    this.hideMailingAddressModal = this.hideMailingAddressModal.bind(this);
    this.state = {
      showRejectTransferFormModal: false,
      showReopenTransferFormModal: false,
      showUpdateAmountFormModal: false,
      showUpdateAccountFormModal: false,
      showCreateActionFormModal: false,
      showSuspendTransferFormModal: false,
      showUpdateWireDescriptionsFormModal: false,
      showReturnTransferFormModal: false,
      showCancelTransferFormModal: false,
      isFirstPartyJournal: false,
      showMailingAddressModal: false,
    };
    this.showAllFields = props.showAllFields;
  }

  componentDidMount() {
    // Fetch the transfer details.
    this.fetchDetails();
  }

  componentDidUpdate(prevProps) {
    if (!isEmpty(this.props.wireUpdateResult) && prevProps.wireUpdateResult !== this.props.wireUpdateResult) {
      this.fetchDetails();
    }

    if (!isEmpty(this.props.suspendWireResult) && prevProps.suspendWireResult !== this.props.suspendWireResult) {
      this.fetchDetails();
    }
    const { transfer, transferAccountValue, wireUpdateFailure } = this.props;

    if (wireUpdateFailure && !isNil(transfer) && transfer.apexAccountNumber !== transferAccountValue) {
      // Redux-Form saves the users inputted value
      // if the update fails this changes the value back to match the apexAccountNumber
      this.props.formInitialize('UpdateAccount', { updatedAccount: transfer.apexAccountNumber || '' }, true);
    }

    if (this.props.transfer) {
      this.setIsFirstPartyCashJournal(this.props.transfer);
    }
  }

  componentWillUnmount() {
    this.props.clearAllErrors();
  }

  setIsFirstPartyCashJournal(transfer) {
    const { method, direction } = transfer;
    if (!isNil(method) && !isNil(direction) && direction === 'JOURNAL' && method.includes(direction)) {
      this.setState({ isFirstPartyJournal: true });
    } else {
      this.setState({ isFirstPartyJournal: false });
    }
  }

  /**
   * Extract and validate the transfer id from React Router
   * match and use it to request details.
   */
  fetchDetails() {
    // eslint-disable-next-line prefer-destructuring
    const id = this.props.match.params.id;
    if (!id) return;
    // perform the request
    this.props.detailsRequest(id, true);
  }

  handleApproveActionSubmit(formData, ...rest) {
    rest[1].reset();
    const payload = {
      comment: formData.comment,
      actionIds: Object.keys(formData)
        .filter(
          (key) =>
            // Filter out actions that are unchecked.
            formData[key] === true &&
            // Also filter out actions that have already been approved.
            !this.props.transfer.prescribedActions.some(
              (action) => action.id === key && action.status === ActionState.Approved,
            ),
        )
        .map((key) => key),
    };
    const approvedActionTypes = [
      ...this.props.transfer.prescribedActions
        .filter((action) => payload.actionIds.includes(action.id))
        .map((action) => action.type),
    ];
    this.props.actionsRequest(
      this.props.transfer.id,
      payload,
      ActionType.Approve,
      `${this.props.intl.formatMessage(messages.submitActionSuccess)} ${approvedActionTypes.join(', ')}`,
      this.props.intl.formatMessage(messages.errorMessagePrefix),
    );
  }

  showMailingAddressModal() {
    this.setState({ showMailingAddressModal: true });
  }

  hideMailingAddressModal() {
    this.setState({ showMailingAddressModal: false });
  }

  showRejectTransferFormModal() {
    this.setState({ showRejectTransferFormModal: true });
  }

  hideRejectTransferFormModal() {
    this.setState({ showRejectTransferFormModal: false });
  }

  showReopenTransferFormModal() {
    this.setState({ showReopenTransferFormModal: true });
  }

  hideReopenTransferFormModal() {
    this.setState({ showReopenTransferFormModal: false });
  }

  showReturnTransferFormModal() {
    this.setState({ showReturnTransferFormModal: true });
  }

  hideReturnTransferFormModal() {
    this.setState({ showReturnTransferFormModal: false });
  }

  showSuspendTransferFormModal() {
    this.setState({ showSuspendTransferFormModal: true });
  }

  hideSuspendTransferFormModal() {
    this.setState({ showSuspendTransferFormModal: false });
  }

  toggleCancelTransferFormModal(isShowing) {
    this.setState({ showCancelTransferFormModal: isShowing });
  }

  handleRejectTransferSubmit(formData) {
    this.hideRejectTransferFormModal();
    this.props.actionsRequest(
      this.props.transfer.id,
      formData,
      ActionType.Reject,
      this.props.intl.formatMessage(messages.rejectTransferSuccess),
    );
    this.fetchDetails();
  }

  handleReopenTransferSubmit(formData) {
    this.hideReopenTransferFormModal();
    this.props.actionsRequest(
      this.props.transfer.id,
      formData,
      ActionType.Reopen,
      this.props.intl.formatMessage(messages.reopenTransferSuccess),
    );
    this.fetchDetails();
  }

  handleCancelTransferSubmit(formData) {
    this.toggleCancelTransferFormModal(false);
    this.props.actionsRequest(
      this.props.transfer.id,
      formData,
      ActionType.Cancel,
      this.props.intl.formatMessage(messages.cancelTransferSuccess),
    );
    this.fetchDetails();
  }

  handleReturnTransferSubmit(formData) {
    this.hideReturnTransferFormModal();
    this.props.suspendWireRequest(
      this.props.transfer.id,
      formData,
      'return',
      this.props.intl.formatMessage(messages.returnTransferSuccess),
    );
    this.fetchDetails();
  }

  handleSuspendWireSubmit(formData) {
    this.hideSuspendTransferFormModal();
    this.props.suspendWireRequest(
      this.props.transfer.id,
      formData,
      'suspend',
      this.props.intl.formatMessage(messages.suspendTransferSuccess),
    );
  }

  showUpdateAmountFormModal() {
    this.setState({ showUpdateAmountFormModal: true });
  }

  hideUpdateAmountFormModal() {
    this.setState({ showUpdateAmountFormModal: false });
  }

  handleUpdateAmountSubmit(formData) {
    this.hideUpdateAmountFormModal();
    const successMessage = `
      ${this.props.intl.formatMessage(messages.updateAmountSuccess)}
        ${formatters.formatDollars(this.props.transfer.amount)}
        to
      ${formatters.formatDollars(Number(formData.updatedAmount))}
    `;
    this.props.actionsRequest(this.props.transfer.id, formData, ActionType.UpdateAmount, successMessage);
    this.fetchDetails();
  }

  showUpdateAccountFormModal() {
    this.setState({ showUpdateAccountFormModal: true });
  }

  hideUpdateAccountFormModal() {
    this.setState({ showUpdateAccountFormModal: false });
  }

  handleUpdateAccountSubmit(formData) {
    this.hideUpdateAccountFormModal();
    const successMessage = `
      ${this.props.intl.formatMessage(messages.updateAccountSuccess)}
        ${this.props.transfer.apexAccountNumber}
        to ${formData.updatedAccount}
    `;

    const { transfer } = this.props;
    // If isDomestic isn't set it should default to true
    const isDomesticNotSet = isNil(transfer && transfer.wireIsDomestic);
    this.props.clearAllErrors();
    this.props.updateWireRequest(
      transfer.id,
      {
        apexAccountNumber: formData.updatedAccount,
        isDomestic: isDomesticNotSet || (transfer && transfer.wireIsDomestic),
        isThirdParty: transfer && !!transfer.wireIsThirdParty,
      },
      successMessage,
    );
  }

  showUpdateWireDescriptionsFormModal() {
    this.setState({ showUpdateWireDescriptionsFormModal: true });
  }

  hideUpdateWireDescriptionsFormModal() {
    this.setState({ showUpdateWireDescriptionsFormModal: false });
  }

  handleUpdateWireDescriptionsSubmit(formData) {
    this.hideUpdateWireDescriptionsFormModal();

    const { transfer } = this.props;
    this.props.clearAllErrors();
    const descriptions = [];
    if (!isEmpty(formData.updatedWireDescription1)) {
      descriptions.push(formData.updatedWireDescription1);
    }

    if (!isEmpty(formData.updatedWireDescription2)) {
      descriptions.push(formData.updatedWireDescription2);
    }

    if (!isEmpty(formData.updatedWireDescription3)) {
      descriptions.push(formData.updatedWireDescription3);
    }
    this.props.updateWireRequest(
      transfer.id,
      {
        ledgerDescriptions: descriptions,
      },
      this.props.intl.formatMessage(messages.updateWireDescriptionsSuccess),
    );
  }

  showCreateActionFormModal() {
    this.setState({ showCreateActionFormModal: true });
  }

  hideCreateActionFormModal() {
    this.setState({ showCreateActionFormModal: false });
  }

  handleCreateActionSubmit(formData, ...rest) {
    this.hideCreateActionFormModal();
    rest[1].reset();
    this.props.actionsRequest(
      this.props.transfer.id,
      formData,
      ActionType.Create,
      `${this.props.intl.formatMessage(messages.actionCreated)} ${formData.comment}`,
    );
    this.fetchDetails();
  }

  goBack() {
    const { location, history } = this.props;
    // Go back in router history if user was linked here from the search page.
    // This way the search page will pre-populate their search.
    if (location.state && location.state.prevPath === '/search') {
      return history.goBack();
    }
    // Otherwise, go to the search page with default search params.
    return history.push('/search');
  }

  hasFullAuth(value) {
    if (this.showAllFields) {
      return value;
    }
    return null;
  }

  renderTransferPanel() {
    const { transfer, transferAccountValue, wireUpdateFailure, addressResult, addressError } = this.props;
    return (
      <TransferPanel
        showAllFields={this.showAllFields}
        id={transfer.id}
        transferState={transfer.state}
        accountOpenedDate={transfer.accountOpenedDate}
        amount={transfer.amount}
        bankAccountNumber={transfer.bankAccountNumber}
        bankAccountIdentifierValue={transfer.bankAccountIdentifierValue}
        dateRequested={transfer.date}
        direction={transfer.direction}
        isFullDisbursement={transfer.isFullDisbursement}
        instructionSource={this.hasFullAuth(transfer.instructionSource)}
        correspondentName={transfer.correspondentName}
        requestedAmount={transfer.requestedAmount}
        achRelationshipEstablishedDate={transfer.achRelationshipEstablishedDate}
        method={transfer.method}
        contraAccount={transfer.contraAccount}
        journalType={transfer.journalType}
        programName={transfer.programName}
        ctsId={this.hasFullAuth(transfer.ctsId)}
        bankConfirmation={transfer.bankConfirmation}
        payor={transfer.payer}
        payorAddress={transfer.payerAddress}
        beneficiary={transfer.beneficiary}
        beneficiaryAddress={transfer.beneficiaryAddress}
        destination={transfer.destinationAccount}
        destinationAddress={transfer.destinationAddress}
        furtherCreditTo={transfer.furtherCreditTo}
        checkCtsId={this.hasFullAuth(transfer.checkCtsId)}
        checkPayer={transfer.checkPayer}
        checkPayerAddress={transfer.checkPayerAddress}
        checkBeneficiary={transfer.checkBeneficiary}
        checkBeneficiaryAddress={transfer.checkBeneficiaryAddress}
        checkDeliveryMethod={transfer.checkDeliveryMethod}
        checkMemo={transfer.checkMemo}
        checkBeneficiaryMailingAddress={addressResult}
        showMailingAddressModal={this.showMailingAddressModal}
        hideMailingAddressModal={this.hideMailingAddressModal}
        showMailingAddressModalState={this.state.showMailingAddressModal}
        mailingAddressError={addressError}
        feeContraAccount={transfer.feeContraAccount}
        feeType={transfer.feeType}
        feeAccountSideDescription={transfer.feeAccountSideDescription}
        feeContraAccountSideDescription={transfer.feeContraAccountSideDescription}
        creditContraAccount={transfer.creditContraAccount}
        creditType={transfer.creditType}
        creditAccountSideDescription={transfer.creditAccountSideDescription}
        creditContraAccountSideDescription={transfer.creditContraAccountSideDescription}
        fedWireReferenceNumber={transfer.fedWireReferenceNumber}
        houseBankAccountNumber={transfer.houseBankAccountNumber}
        externalId={transfer.externalId}
        isDomestic={transfer.wireIsDomestic}
        isThirdParty={transfer.wireIsThirdParty}
        wireIsReturn={transfer.wireIsReturn}
        updateWireDetails={transfer.updateWireDetails}
        isFirstPartyJournal={this.state.isFirstPartyJournal}
        transferAccountValue={transferAccountValue}
        wireUpdateFailure={wireUpdateFailure}
        payPalStatus={transfer.payPalStatus}
        payPalRelationshipId={transfer.payPalRelationshipId}
        payPalEstablishedDate={transfer.payPalEstablishedDate}
        positionDetails={transfer.positionDetails}
        sourceType={transfer.sourceType}
        rtpTransactionId={transfer.rtpTransactionId}
      />
    );
  }

  render() {
    const {
      transfer,
      shouldAllowEditAmount,
      isDetailsLoading,
      searchServiceTransferId,
      hasActionResolvableByCurrentUser,
      atlasResults,
    } = this.props;
    const formattedTransferState = transfer && formatters.formatTransferState(transfer.state);
    const hasRecentACHDeposit =
      transfer &&
      transfer.prescribedActions.some(
        (prescribedAction) => prescribedAction.type === EvaluatedActionType.RecentAchDeposit,
      );

    const isIncomingWire = transfer && IS_INCOMING_WIRE(transfer.method, transfer.direction);
    const isPositionJournal = transfer && transfer.method === TRANSFER_TYPES.positionJournal;

    return (
      <div className={styles.details}>
        {isDetailsLoading && <Spinner />}
        {!isDetailsLoading && !transfer && (
          <div className={styles.noResults}>
            <FormattedMessage {...messages.noResults} /> {searchServiceTransferId}
          </div>
        )}
        {transfer && (
          <div>
            <DetailsHeader
              amount={transfer.amount}
              allowEditAmount={shouldAllowEditAmount}
              allowEditAccount={transfer.updateWireDetails}
              onEditAmountButtonClicked={this.showUpdateAmountFormModal}
              onEditAccountButtonClicked={this.showUpdateAccountFormModal}
              amountAvailableTotal={transfer.amountAvailableTotal}
              apexAccountNumber={transfer.apexAccountNumber}
              correspondentName={transfer.correspondentName}
              state={formattedTransferState}
              method={transfer.method}
              direction={transfer.direction}
              reject={transfer.reject}
              rejectAction={this.showRejectTransferFormModal}
              reopen={transfer.resurrect}
              reopenAction={this.showReopenTransferFormModal}
              suspend={transfer.suspend}
              suspendAction={this.showSuspendTransferFormModal}
              hasReturn={transfer.hasReturn}
              returnAction={this.showReturnTransferFormModal}
              isFirstPartyJournal={this.state.isFirstPartyJournal}
              cancel={transfer.cancel}
              cancelAction={() => this.toggleCancelTransferFormModal(true)}
              positionDetails={transfer.positionDetails}
            />
            <Grid>
              <div className={styles.buttonGroup}>
                <button onClick={this.goBack} className={styles.backToSearch} data-test-handle="backToSearch">
                  <FaArrowLeft className={styles.arrowLeft} />
                  <FormattedMessage {...messages.backToSearch} />
                </button>
              </div>
              <div className={styles.separator} />
              <Row className={styles.displayFlex}>
                {isIncomingWire && <WireInstructionPanel wireInstructions={transfer.wireInstructions} />}
                {isPositionJournal && this.renderTransferPanel()}
                {!isIncomingWire && !isPositionJournal && (
                  <AmountAvailablePanel
                    startDayCashAvailable={transfer.amountAvailableStartDayCashAvailable}
                    pendingDebitInterest={transfer.amountAvailablePendingDebitInterest}
                    pendingDebitDividends={transfer.amountAvailablePendingDebitDividends}
                    totalDisbursements={transfer.amountAvailableTotalDisbursements}
                    totalDeposits={transfer.amountAvailableTotalDeposits}
                    total={transfer.amountAvailableTotal}
                    direction={transfer.direction}
                    allowFullyPaidUnsettledFunds={transfer.amountAvailableAllowFullyPaidUnsettledFunds}
                    fullyPaidUnsettledFundsAmount={transfer.amountAvailableFullyPaidUnsettledFundsAmount}
                    amountRecentDepositThreshold={transfer.amountRecentDepositThreshold}
                  />
                )}
                <ActionsPanel
                  handleSubmit={this.handleApproveActionSubmit}
                  prescribedActionsData={transfer.prescribedActions || []}
                  hasActionResolvableByCurrentUser={hasActionResolvableByCurrentUser}
                  showCreateActionFormModal={this.showCreateActionFormModal}
                  showCreateActionButton={transfer.createReviewAction}
                />
              </Row>
              <Row className={styles.displayFlex}>
                {!isPositionJournal && this.renderTransferPanel()}
                <TabbedDetailsPanel
                  panelName="AccountPanel"
                  isFirstPartyJournal={this.state.isFirstPartyJournal}
                  offset={isPositionJournal ? 6 : null}
                >
                  {!isIncomingWire && (
                    <AccountPanel
                      showAllFields={this.showAllFields}
                      title={<FormattedMessage {...messages.account} />}
                      apexAccountNumber={transfer.apexAccountNumber}
                      isAccountActive={this.hasFullAuth(transfer.accountIsActive)}
                      correspondentName={this.hasFullAuth(transfer.correspondentName)}
                      correspondentDeposit={transfer.correspondentDeposit}
                      accountOpenedDate={transfer.accountOpenedDate}
                      restrictionCodes={atlasResults.restrictionCode}
                    />
                  )}
                  {isIncomingWire && (
                    <IncomingWiresAccountPanel
                      title={<FormattedMessage {...messages.account} />}
                      apexAccountNumber={transfer.apexAccountNumber}
                      correspondentName={transfer.correspondentName}
                      accountOpenedDate={transfer.accountOpenedDate}
                      onEditAccountButtonClicked={this.showUpdateAccountFormModal}
                      allowEditAccount={transfer.updateWireDetails}
                      beneficiaryName={transfer.wireDepositBeneficiaryName}
                      beneficiaryAddress={transfer.wireDepositBeneficiaryAddress}
                    />
                  )}
                  {isIncomingWire && (
                    <WireDescriptionsPanel
                      title={<FormattedMessage {...messages.descriptions} />}
                      wireLedgerDescriptions={transfer.wireDescriptions}
                      onEditDescriptionsButtonClicked={this.showUpdateWireDescriptionsFormModal}
                      allowEditDescriptions={transfer.updateWireDetails}
                    />
                  )}
                  {transfer.method === TRANSFER_TYPES.journal &&
                    !this.state.isFirstPartyJournal &&
                    !isPositionJournal && (
                      <TravelRuleDetailsPanel
                        title={<FormattedMessage {...messages.travelRuleDetails} />}
                        originatingInstitutionName={transfer.originatingInstitutionName}
                        originatingInstitutionAccountNumber={transfer.originatingInstitutionAccountNumber}
                        recipientInstitutionName={transfer.recipientInstitutionName}
                        recipientInstitutionAccountNumber={transfer.recipientInstitutionAccountNumber}
                        originatorFirstName={transfer.originatorFirstName}
                        originatorLastName={transfer.originatorLastName}
                        originatorAddress={transfer.originatorAddress}
                        originatorEntityName={transfer.originatorEntityName}
                        recipientFirstName={transfer.recipientFirstName}
                        recipientLastName={transfer.recipientLastName}
                        recipientAddress={transfer.recipientAddress}
                        recipientEntityName={transfer.recipientEntityName}
                      />
                    )}
                  {!isEmpty(transfer.openMarginCalls) && (
                    <MarginCallPanel
                      title={<FormattedMessage {...messages.marginCalls} />}
                      marginCalls={transfer.openMarginCalls}
                    />
                  )}
                  {hasRecentACHDeposit && (
                    <RecentDepositsPanel
                      title={<FormattedMessage {...messages.recentDeposits} />}
                      recentDeposits={this.props.recentDepositsResults}
                    />
                  )}
                  {transfer.method !== TRANSFER_TYPES.credit &&
                    transfer.method !== TRANSFER_TYPES.fee &&
                    !isPositionJournal && (
                      <TransferFeesPanel title={<FormattedMessage {...messages.transferFees} />} fees={transfer.fees} />
                    )}
                </TabbedDetailsPanel>
              </Row>
              {(transfer.iraDistributionReason || transfer.iraContributionDetailsType) && (
                <Row className={styles.displayFlex}>
                  <RetirementPanel
                    distributionReason={transfer.iraDistributionReason}
                    federalTaxWithholdingType={transfer.iraFederalTaxWithholdingType}
                    federalTaxWithholdingValue={transfer.iraFederalTaxWithholdingValue}
                    stateTaxWithholdingValue={transfer.iraStateTaxWithholdingValue}
                    stateTaxWithholdingType={transfer.iraStateTaxWithholdingType}
                    accountRegistration={transfer.accountRegistration}
                    iraReceivingInstitutionName={transfer.iraReceivingInstitutionName}
                    iraContributionDetailsType={transfer.iraContributionDetailsType}
                    iraContributionApplyToPriorYear={transfer.iraContributionApplyToPriorYear}
                    transferDirection={transfer.direction}
                  />
                </Row>
              )}
              <Row className={styles.displayFlex}>
                <AuditTrailPanel auditTrailData={transfer.auditEvents} intl={this.props.intl} />
              </Row>
            </Grid>
          </div>
        )}
        <RejectTransferForm
          show={this.state.showRejectTransferFormModal}
          onHide={this.hideRejectTransferFormModal}
          onSubmit={this.handleRejectTransferSubmit}
        />
        <ReopenTransferForm
          show={this.state.showReopenTransferFormModal}
          onHide={this.hideReopenTransferFormModal}
          onSubmit={this.handleReopenTransferSubmit}
        />
        <ReturnTransferForm
          show={this.state.showReturnTransferFormModal}
          onHide={this.hideReturnTransferFormModal}
          onSubmit={this.handleReturnTransferSubmit}
        />
        <SuspendWireTransferForm
          show={this.state.showSuspendTransferFormModal}
          onHide={this.hideSuspendTransferFormModal}
          onSubmit={this.handleSuspendWireSubmit}
        />
        <CancelTransferForm
          show={this.state.showCancelTransferFormModal}
          onHide={() => {
            this.toggleCancelTransferFormModal(false);
          }}
          onSubmit={this.handleCancelTransferSubmit}
        />
        <UpdateAmountForm
          show={this.state.showUpdateAmountFormModal}
          onHide={this.hideUpdateAmountFormModal}
          onSubmit={this.handleUpdateAmountSubmit}
          initialValues={{ updatedAmount: transfer ? transfer.amount : 0 }}
        />
        <UpdateAccountForm
          show={this.state.showUpdateAccountFormModal}
          onHide={this.hideUpdateAccountFormModal}
          onSubmit={this.handleUpdateAccountSubmit}
          initialValues={{ updatedAccount: transfer ? transfer.apexAccountNumber : ' ' }}
        />
        <UpdateWireDescriptionsForm
          show={this.state.showUpdateWireDescriptionsFormModal}
          onHide={this.hideUpdateWireDescriptionsFormModal}
          onSubmit={this.handleUpdateWireDescriptionsSubmit}
          initialValues={{
            updatedWireDescription1: transfer && transfer.wireDescriptions ? transfer.wireDescriptions[0] : '',
            updatedWireDescription2: transfer && transfer.wireDescriptions ? transfer.wireDescriptions[1] : '',
            updatedWireDescription3: transfer && transfer.wireDescriptions ? transfer.wireDescriptions[2] : '',
          }}
        />
        <CreateActionForm
          show={this.state.showCreateActionFormModal}
          onHide={this.hideCreateActionFormModal}
          onSubmit={this.handleCreateActionSubmit}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = (/*state*/) =>
  createStructuredSelector({
    transfer: selectResult,
    recentDepositsResults: selectRecentDeposits,
    shouldAllowEditAmount: selectShouldAllowEditAmount,
    isDetailsLoading: selectIsDetailsServiceLoading,
    searchServiceTransferId: selectTransferId,
    hasActionResolvableByCurrentUser: selectHasActionResolvableByCurrentUser,
    wireUpdateResult: selectWireResult,
    showAllFields: selectShowAllFields,
    wireUpdateFailure: selectUpdateWireFailure,
    transferAccountValue: accountFormSelector,
    suspendWireResult: selectSuspendWireResult,
    atlasResults: selectAtlasResults,
    addressResult: selectAddressResults,
    addressError: selectAddressError,
  });

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      detailsRequest,
      actionsRequest,
      updateWireRequest,
      suspendWireRequest,
      clearAllErrors,
      addressRequest,
      formInitialize: initialize,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Details));



// WEBPACK FOOTER //
// ./src/containers/Details/index.js